<div><img [src]="picture()" onerror="this.src = 'assets/img/user/default.jpg'" alt="Avatar" /></div>
<p class="user-block-name">{{username()}}</p>
